<template>
  <button
    type="button"
    class="change-active-diet__item"
    :class="{ 'change-active-diet__item--active': diet.isActive }"
    :data-test-id="`ChangeActiveDiet-item-${diet.id}`"
    @click="emit('select', diet.id)"
  >
    <div class="change-active-diet__item-content">
      <span class="change-active-diet__item-name">{{ diet.name }}</span>
      <span class="change-active-diet__item-dates">
        {{ diet.dateRange ?? "Brak ustawionej daty" }}
      </span>
    </div>
    <div class="change-active-diet__item-meta">
      <span class="badge" :class="badgeClass">{{ diet.status }}</span>
      <BaseIcon v-if="diet.isActive" name="check" class="change-active-diet__check" />
    </div>
  </button>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import BaseIcon from '@/components/BaseIcon.vue'

  import type { ActiveDietItem } from '../../types'

  const props = defineProps<{ diet: ActiveDietItem }>()
  const emit = defineEmits<{ select: [dietId: number] }>()
  const badgeClass = computed(() => ({
    'badge--archived': props.diet.status === 'Archiwalny',
    'badge--draft': props.diet.status === 'Szkic',
    'badge--published': props.diet.status === 'Gotowy',
  }))
</script>

<style scoped>
  .change-active-diet__item {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 8px;
    text-align: left;
    cursor: pointer;
    background: none;
    border: none;
    border-radius: 6px;
    transition: background 0.15s;
  }

  .change-active-diet__item:last-child {
    border-bottom: none;
  }

  .change-active-diet__item:hover,
  .change-active-diet__item--active {
    background: #fafafa;
  }

  .change-active-diet__item-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .change-active-diet__item-name {
    margin-bottom: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #535862;
    overflow-wrap: break-word;
  }

  .change-active-diet__item-dates {
    font-size: 14px;
    font-weight: 600;
    color: #414651;
  }

  .change-active-diet__item-meta {
    display: flex;
    flex-shrink: 0;
    gap: 8px;
    align-items: center;
  }

  .change-active-diet__check {
    flex-shrink: 0;
    color: #1b412a;
  }

  .badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid;
    border-radius: 6px;
  }

  .badge--draft {
    color: #b54708;
    background: #fffaeb;
    border-color: #fedf89;
  }

  .badge--published {
    color: #067647;
    background: #ecfdf3;
    border-color: #abefc6;
  }

  .badge--archived {
    color: #1a1a1a;
    background: #f8f8f8;
    border-color: #cacaca;
  }
</style>
